import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Fade,
  Grid,
  LinearProgress,
  Paper,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import { Fragment, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { animList1 } from "../../utilities/anim";
import AuthDialog from "../../components/authDialog";
import { NavContext, SplashContext } from "../layout/layout";
import getTickets from "./utilities/getTickets";
import { setTickets } from "../../redux/slices/ticketsSlice";
import { Download, OpenInNew } from "@mui/icons-material";
import fileDownload from "js-file-download";
import generateReceipt from "./utilities/generateReceipt";
import { AuthContext } from "../../context/auth/authContext";
import { receiptEndpoint } from "../../routes/api_endpoints";

const MyTickets = () => {
  /* #region  Redux */
  const _tickets = useSelector((state) => state.ticketsReducer.tickets);
  const dispatch = useDispatch();
  /* #endregion */

  /* #region  State and UI controllers */
  const [apiTickets, setApiTickets] = useState([]);
  const [ticketsLoading, setTicketsLoading] = useState(false);
  // const [page] = useState(0);
  // const [rowsPerPage] = useState(5);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [downloading, setDownloading] = useState({});
  const [snackBarOpen, setSnackbarOpen] = useState(false);
  const authContext = useContext(AuthContext);

  const splashScreen = useContext(SplashContext);
  const navBarHeight = useContext(NavContext);
  /* #endregion */

  /* #region  Styles */
  const spanFontSizes1 = {
    fontSize: { lg: "1.125rem", md: "1rem", sm: "0.875rem", xs: "0.875rem" },
  };
  const Text1 = ({ children }) => {
    return (
      <Typography
        component="span"
        fontWeight={300}
        sx={{ ...spanFontSizes1, wordWrap: "break-word" }}
      >
        {children}
      </Typography>
    );
  };
  const Text2 = ({ children }) => {
    return (
      <Typography
        variant={"h6"}
        fontWeight={500}
        fontSize={{
          xs: "1.25rem",
          sm: "1.5rem",
        }}
      >
        {children}
      </Typography>
    );
  };
  /* #endregion */

  /* #region  Api calls and initialization */
  const getTicketsFromApi = (MobileNumber) =>
    new Promise((resolve, reject) => {
      setTicketsLoading(true);
      getTickets(MobileNumber)
        .then((tickets) => {
          setTicketsLoading(false);
          setApiTickets(tickets);
          dispatch(setTickets(tickets));
          resolve();
        })
        .catch((error) => {
          setTicketsLoading(false);
          if (_tickets.length > 0) {
            setApiTickets(_tickets);
            resolve();
          } else {
            reject();
          }
        });
    });

  useEffect(() => {
    setDialogOpen(!authContext.loggedIn);
    if (authContext.loggedIn) {
      getTicketsFromApi(authContext.userDetails.MobileNumber);
    }
    splashScreen();
    animList1();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authContext.loggedIn]);
  /* #endregion */

  return (
    <Container
      sx={{
        p: 2,
        minHeight: `calc(100vh - ${navBarHeight}px)`,
      }}
      maxWidth="lg"
    >
      {authContext.loggedIn ? (
        <Stack>
          <Typography variant="h4" mb={2}>
            Your tickets
          </Typography>
          <Typography variant="body2" mb={2}>
            You can also access your tickets from the Little App.
          </Typography>
          <Grid container spacing={2}>
            {ticketsLoading ? (
              <>
                <Grid
                  item
                  xs={12}
                  m={1}
                  height={"50vh"}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </Grid>
              </>
            ) : (
              <>
                {apiTickets.length > 0 ? (
                  apiTickets.map((ticket, index) => (
                    <Fragment key={ticket.BookingID}>
                      <Grid item xs={12} md={6}>
                        <Fade in>
                          <Paper
                            elevation={2}
                            sx={{
                              p: 2,
                              border: `1px solid rgb(200,200,200)`,
                            }}
                          >
                            <Stack spacing={2}>
                              <Stack
                                spacing={2}
                                direction={"row"}
                                height={"fit-content"}
                              >
                                <Box
                                  component="img"
                                  sx={{
                                    height: {
                                      xs: "25vh",
                                      sm: "30vh",
                                    },
                                    objectFit: "cover",
                                    border: "1px solid rgb(200,200,200)",
                                    borderRadius: "5px",
                                    aspectRatio: "600/950",
                                  }}
                                  src={ticket.MovieImageSmall}
                                  alt={"movie_image"}
                                ></Box>

                                <Stack spacing={1} justifyContent={"stretch"}>
                                  <Text2>{ticket.MovieName}</Text2>
                                  <Text1>
                                    {ticket.MovieProvider &&
                                      ticket.MovieProvider[0].Name}
                                  </Text1>

                                  <Text1>Date: {ticket.ShowDate}</Text1>
                                  <Text1>
                                    Seats:{" "}
                                    {ticket.Seats &&
                                      ticket.Seats.map((seat, index) => (
                                        <span key={seat.SeatNumber}>
                                          {seat.SeatNumber},
                                        </span>
                                      ))}
                                  </Text1>
                                </Stack>
                              </Stack>
                              {ticket.BookingID && (
                                <Button
                                  variant="contained"
                                  sx={{ width: "100%" }}
                                  onClick={() => {
                                    window.open(
                                      `${receiptEndpoint}/${authContext.userDetails.MobileNumber}/${ticket.BookingID}`,
                                      "_blank"
                                    );
                                  }}
                                >
                                  View ticket&nbsp;
                                  <OpenInNew />
                                </Button>
                              )}

                              {false && (
                                <>
                                  <Button
                                    variant="contained"
                                    sx={{ width: "100%" }}
                                    disabled={
                                      downloading[ticket.BookingID] &&
                                      downloading[ticket.BookingID].downloading
                                    }
                                    onClick={() => {
                                      setDownloading((prevState) => {
                                        let obj = { ...prevState };
                                        obj[ticket.BookingID] = {
                                          downloading: true,
                                          progress: 0,
                                        };
                                        return obj;
                                      });
                                      generateReceipt(
                                        ticket,
                                        (progressEvent) => {
                                          setDownloading((prevState) => {
                                            let obj = { ...prevState };
                                            obj[ticket.BookingID] = {
                                              downloading: true,
                                              progress:
                                                (progressEvent.loaded /
                                                  progressEvent.total) *
                                                100,
                                            };
                                            return obj;
                                          });
                                        }
                                      )
                                        .then((blob) => {
                                          fileDownload(
                                            blob,
                                            `${ticket.MovieName}-receipt.pdf`
                                          );
                                          setDownloading((prevState) => {
                                            let obj = { ...prevState };
                                            obj[ticket.BookingID] = {
                                              downloading: false,
                                              progress: 100,
                                            };
                                            return obj;
                                          });
                                        })
                                        .catch((error) => {
                                          setSnackbarOpen(true);
                                        });
                                    }}
                                  >
                                    {downloading[ticket.BookingID] &&
                                      downloading[ticket.BookingID]
                                        .downloading && (
                                        <CircularProgress size={"16px"} />
                                      )}
                                    &emsp;Download receipt&emsp;
                                    <Download fontSize="small" />
                                  </Button>
                                  {downloading[ticket.BookingID] &&
                                    downloading[ticket.BookingID]
                                      .downloading && (
                                      <LinearProgress
                                        variant="determinate"
                                        value={
                                          downloading[ticket.BookingID].progress
                                        }
                                      />
                                    )}
                                </>
                              )}
                            </Stack>
                          </Paper>
                        </Fade>
                      </Grid>
                    </Fragment>
                  ))
                ) : (
                  <>No tickets</>
                )}
              </>
            )}
          </Grid>
        </Stack>
      ) : (
        <Stack height="40vh" spacing={2} justifyContent="center">
          <Typography variant="h4">
            Please enter your phone number to continue
          </Typography>
          <Button
            variant="contained"
            onClick={() => setDialogOpen(true)}
            sx={{ width: "fit-content" }}
          >
            Enter phone number
          </Button>
        </Stack>
      )}
      <Snackbar
        onClose={() => setSnackbarOpen(false)}
        autoHideDuration={6000}
        open={snackBarOpen}
      >
        <Alert severity="error" onClose={() => setSnackbarOpen(false)}>
          Something went wrong
        </Alert>
      </Snackbar>
      <AuthDialog
        open={dialogOpen}
        setOpen={setDialogOpen}
        onLogin={() => {}}
        onFail={(phone) => {
          getTicketsFromApi(phone);
        }}
        title="Enter your phone number"
        subTitle="Please enter your phone number to continue"
      />
    </Container>
  );
};
export default MyTickets;
